var app = angular.module("leonardo");

var ChangeDateDialog = function($scope, $q, $state, ngDialog, FormErrorsService, UserService, AccountUserRoleService, NoteService, $rootScope) {
  $scope.task = $scope.ngDialogData.task;
  $scope.taskInfo = $scope.ngDialogData.taskInfo;
  $scope.action = $scope.ngDialogData.action;
  $scope.actionItems = $scope.ngDialogData.actionItems;
  $scope.note = $scope.ngDialogData.note;
  $scope.userService = UserService;
  $scope.accountUserRoleService = AccountUserRoleService;
  $scope.showDependent = false;
  $scope.data = {};
  $scope.data.reason = null;
  $scope.keepOriginal = null;
  $scope.dependentChild = [];
  $scope.workflowActions = [];
  $scope.getWorkflowActions = function(){
    if($scope.actionItems.length > 0){
      $scope.actionItems.forEach(actionItem =>{
        if($scope.task.workflow_instance.id === actionItem.workflow_instance_id){
            $scope.workflowActions.push(actionItem);
        }
      })
    }
  }
  $scope.getWorkflowActions();
  $scope.data.make_read_by_date = $scope.ngDialogData.moveInDate ? $scope.ngDialogData.moveInDate : $scope.workflowActions.length > 0 ? $scope.workflowActions[$scope.workflowActions.length - 1].due_date  : '';

  $scope.ReasonOptions = [{'id': 1, 'name': 'Vendor Delay'},
  {'id': 2, 'name': 'Property Delay'},
  {'id': 3, 'name': 'Weather Delay'},
  {'id': 0, 'name': 'Other'}];

  $scope.originalDates = [
    {
      id: 1,
      name: 'Yes'
    },
    {
      id: 0,
      name: 'No'
    },
  ];

  $scope.updateDependentTaskDate = function () {
    $scope.dependentChild = [];
    if ($scope.taskInfo.children && $scope.taskInfo.children.length > 0) {
      $scope.showBeyondWarning = false;
      $scope.taskInfo.children.forEach((child) => {
        if (child.lag_type == 1) {
          let oldDueDate = moment($scope.taskInfo.due_date.toString(), 'YYYY/MM/DD');
          let difference = moment($scope.data.new_date.toString(), 'YYYY/MM/DD').diff(oldDueDate, 'days');
          if(difference >= 0){
            child.newDate =  moment(child.due_date.toString(), 'YYYY/MM/DD').add(difference, 'days').format('YYYY-MM-DD');
          }
          else{
            let daysToSub = Math.abs(difference);
            child.newDate =  moment(child.due_date.toString(), 'YYYY/MM/DD').subtract(daysToSub, 'days').format('YYYY-MM-DD');
          }
          $scope.dependentChild.push(child);
          if ($scope.ngDialogData.moveInDate && moment(child.newDate).isAfter(moment($scope.ngDialogData.moveInDate))) {
            $scope.showBeyondWarning = true;
          }
          $scope.showDependent = true;
        }
      });
    }
  };

  $scope.$watch('data.new_date', function(newValue, oldValue){
    if(newValue && newValue != oldValue){
      $scope.updateDependentTaskDate();
    }
  })

  $scope.changeKeepOriginal = function(id){
    $scope.keepOriginal = id;
  }

  $scope.submit = function() {
    console.log($scope.Form,'form')
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid || ($scope.dependentChild.length > 0 && $scope.keepOriginal == null)) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    data['actionitem_set'] = [];
    data['actionitem_set'].push($scope.task.id);
    data['reason'] = parseInt(data['reason']);
    data['update_child'] = $scope.keepOriginal === 1 ? false : true;
    $scope.task.changeDate(data).then(function(data_result) {
      if(data.text && data.text != ''){
        NoteService.post(data).then(function(note) {
          $scope.task.notes.push(note);
          $scope.closeThisDialog();
          $rootScope.$broadcast('task-change-date-dialog:success', $scope.task);
        });
      }
      else{
        $scope.closeThisDialog();
        $rootScope.$broadcast('task-change-date-dialog:success', $scope.task);
      }
     
    });
  };
};

app.controller('ChangeDateDialog', ['$scope', '$q', '$state', 'ngDialog', 'FormErrorsService', 'UserService', 'AccountUserRoleService', 'NoteService', '$rootScope', ChangeDateDialog]);
